import React from "react";
import { useField } from "react-final-form";
import { useIntl } from "react-intl";
import { useAlgoliaSearch } from "../algolia/useAlgoliaSearch";
import Box from "../box/Box";
import MultiTagSelector from "../selectors/MultiTagSelector";
import ErrorMessage from "../form/ErrorMessage";

export enum ITagType {
  Product = "PRODUCT",
  Story = "STORY",
  Project = "PROJECT",
  Department = "DEPARTMENT",
  Award = "AWARD",
  Custom = "CUSTOM",
}

interface ITagAlgoliaHit {
  objectID: string;
  name: string;
}

interface ITagsFieldProps {
  fieldName: string;
  type: ITagType | ITagType[];
}

export function parseFacetFilters(type: ITagType | ITagType[]) {
  if (Array.isArray(type) && type.length > 0) {
    return [[...type.map(value => `types:${value}`)]];
  }

  return [`types:${type}`];
}

export default function TagsField({ fieldName, type }: ITagsFieldProps) {
  const { input, meta } = useField(fieldName);
  const intl = useIntl();
  const { setSearchState, results } = useAlgoliaSearch<ITagAlgoliaHit>({
    initialSearchState: {
      index: "tags",
      facetFilters: parseFacetFilters(type),
    },
  });

  return (
    <Box>
      <MultiTagSelector
        id="tags-selector"
        selectedTags={input.value}
        tags={results?.hits.map(hit => ({ value: hit.objectID, label: hit.name })) || []}
        onChange={input.onChange}
        onBlur={() => input.onBlur()}
        placeholder={intl.formatMessage({ defaultMessage: 'Type a tag name... ', id: '0OUXdu' })}
        onInputValueChange={query => setSearchState(currentState => ({ ...currentState, query }))}
        inputProps={{
          invalid: meta.error && meta.touched,
        }}
      />
      <ErrorMessage text={meta.error} visible={meta.touched && meta.error} />
    </Box>
  );
}
